import { FilterOperationsProvider } from "./filter-operations-provider";
import { FilterOperators } from "./filter-operators";

export class StandardFilterOperations implements FilterOperationsProvider {
    applyOperation(itemToBeFiltered: any, filterValue: any, filterOperation: string): boolean {
        switch (filterOperation) {
            case FilterOperators.Equal:
                return itemToBeFiltered == filterValue;
            case FilterOperators.NotEqual:
                return itemToBeFiltered != filterValue;
            case FilterOperators.GreaterThan:
                return itemToBeFiltered > filterValue;
            case FilterOperators.GreaterThanOrEqual:
                return itemToBeFiltered >= filterValue;
            case FilterOperators.LessThan:
                return itemToBeFiltered < filterValue;
            case FilterOperators.LessThanOrEqual:
                return itemToBeFiltered <= filterValue;
            case FilterOperators.In:
                return filterValue.includes && filterValue.includes(itemToBeFiltered);
            case FilterOperators.NotIn:
                return filterValue.includes && !filterValue.includes(itemToBeFiltered);
            case FilterOperators.Contains:
                return ('' + (itemToBeFiltered || '')).toLowerCase().includes(String(filterValue).toLowerCase());
            case FilterOperators.DoesNotContain:
                return !('' + (itemToBeFiltered || '')).toLowerCase().includes(String(filterValue).toLowerCase());
            case FilterOperators.IsEmpty:
                return (itemToBeFiltered == undefined);
            case FilterOperators.Between:
                return itemToBeFiltered >= filterValue.field1 && itemToBeFiltered <= filterValue.field2;
            default:
                return itemToBeFiltered === filterValue;
        }
    }
}